import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    DialogActions,
    Button,
    Box
} from '@mui/material';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuction } from '../context/AuctionContext';
import { useNotification } from '../context/NotificationContext';
import { containers } from '../theme/commonStyles';

function BudgetTeamsModal({ open, onClose }) {
    const { auctionId } = useAuction();
    const notify = useNotification();
    const [participants, setParticipants] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (open && auctionId) {
            const fetchParticipants = async () => {
                setLoading(true);
                try {
                    const participantsQuery = query(
                        collection(db, 'auctions', auctionId, 'participants'),
                        orderBy('name', 'asc')
                    );
                    const participantsSnap = await getDocs(participantsQuery);
                    const participantsList = participantsSnap.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    setParticipants(participantsList);
                } catch (err) {
                    console.error("Error fetching participants:", err);
                    notify.error("Kon deelnemersinformatie niet ophalen.");
                } finally {
                    setLoading(false);
                }
            };
            fetchParticipants();
        }
    }, [open, auctionId, notify]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Budget Teams</DialogTitle>
            <DialogContent>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <Box sx={{ ...containers.glassContainer, mt: 2 }}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Naam</TableCell>
                                        <TableCell align="right">Resterende transfers</TableCell>
                                        <TableCell align="right">Resterend budget</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {participants.map((p) => (
                                        <TableRow key={p.id}>
                                            <TableCell>{p.name}</TableCell>
                                            <TableCell align="right">{p.transfersLeft || 0}</TableCell>
                                            <TableCell align="right">
                                                {new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(p.budget)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Sluiten</Button>
            </DialogActions>
        </Dialog>
    );
}

export default BudgetTeamsModal;
